import React, { Fragment, useEffect } from 'react'
import { Link } from 'react-router'
import { Button } from 'react-bootstrap'

import './MarketReportsWidget.scss'
import { translate } from 'react-translate'

const MarketReportsWidgetComponent = ({ imi, loadNotes, notes, t }) => {

  useEffect(() => {
    loadNotes(imi.id)
  }, [])

  const description = notes && notes.length && notes[0].bajada

  // informes-del-mercado-inmobiliario/
  return <Fragment>
    <div className='market-report-main-text'>
      <h2>{t('title')}</h2>
      <p>
        {t('text')}
      </p>
    </div>
    <div className='market-reports-widget'>
      <div className='market-item'>
        <img src={imi.image} />
        <div className='market-text'>
          <h3 className='visible-xs'>Informe destacado</h3>
          <h2>{imi.nombre}</h2>
          <h3 className='hidden-xs'>Informe destacado</h3>
          {description && <h4>
            {description}
          </h4>}

          <div className='market-btns'>
            <Link
              className='btn btn-primary' title='Ver interactivo' to={`/informes-del-mercado-inmobiliario/${imi.id}`}
            >
              {t('view_interactive')}
            </Link>
            <Link className='btn btn-secondary' to='/informes-del-mercado-inmobiliario' title='Ver nuestros Informes'>
              {t('view_report')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
}

export const MarketReportsWidget = translate('MarketReportsWidget')(MarketReportsWidgetComponent)



// WEBPACK FOOTER //
// ./src/features/commons/MarketReportsWidget/MarketReportsWidget.component.js